import React, { useCallback, useEffect, useRef } from 'react';
import { usePlayerUIContext, showUI, hideUI } from '@24i/player-ui';
import { useEvent } from '@24i/nxg-core-utils';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { Hideable, PointerEventsHandler } from './styled';
export const HideableContainer = ({ children, className, showTime, displayed, onShow, onHide, onDisplayedChange, style, }) => {
    const { state: { uiDisplayed }, dispatch, } = usePlayerUIContext();
    const displayTimer = useRef();
    const pointerDown = useRef(false);
    const shouldViewBeDisplayed = displayed !== null && displayed !== void 0 ? displayed : uiDisplayed;
    const uiOverlayHideTime = useFeature('uiOverlayHideTime');
    const showTimeUI = uiOverlayHideTime ? uiOverlayHideTime * 1000 : showTime;
    const canDisplay = displayed !== false;
    const unscheduleHide = useCallback(() => {
        if (displayTimer.current) {
            clearTimeout(displayTimer.current);
            displayTimer.current = undefined;
        }
    }, []);
    const hide = useEvent(() => {
        dispatch(hideUI());
        onHide();
        unscheduleHide();
    });
    const scheduleHide = useCallback(() => {
        if (!pointerDown.current) {
            displayTimer.current = setTimeout(hide, showTimeUI);
        }
    }, []);
    const rescheduleHide = useCallback(() => {
        unscheduleHide();
        scheduleHide();
    }, []);
    const show = useEvent(() => {
        if (!shouldViewBeDisplayed)
            dispatch(showUI());
        onShow();
        rescheduleHide();
    });
    const onPointerDown = useEvent(() => {
        pointerDown.current = true;
        show();
    });
    const onPointerMove = useEvent(() => {
        show();
    });
    const onPointerUp = useEvent(() => {
        pointerDown.current = false;
        rescheduleHide();
    });
    useEffect(() => {
        displayTimer.current = setTimeout(hide, showTimeUI);
        return () => {
            if (displayTimer.current) {
                clearTimeout(displayTimer.current);
                displayTimer.current = undefined;
            }
        };
    }, []);
    useEffect(() => {
        if (onDisplayedChange) {
            onDisplayedChange(shouldViewBeDisplayed);
        }
    }, [shouldViewBeDisplayed]);
    const finalClassName = `HideableContainer ${className}${shouldViewBeDisplayed ? ' showing-controls' : ''}`;
    return (React.createElement(Hideable, { "data-test": "HideableContainer", className: finalClassName, onTouchStart: onPointerDown, onTouchMove: onPointerMove, onTouchEnd: onPointerUp, onMouseDown: onPointerDown, onMouseMove: onPointerMove, onMouseUp: onPointerUp, displayed: shouldViewBeDisplayed, style: style },
        React.createElement(PointerEventsHandler, { canParentDisplay: canDisplay, parentDisplayed: shouldViewBeDisplayed }),
        children));
};
HideableContainer.displayName = 'HideableContainer';
HideableContainer.defaultProps = {
    showTime: 5000,
    className: '',
    onShow: () => { },
    onHide: () => { },
    style: null,
};
//# sourceMappingURL=index.js.map